import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from "@/components/ui/card";
/**
 * Generic skeleton for "list of cards" pages — used while data is loading so
 * the page doesn't flash an "Empty" state during a channel switch.
 */
export function ListSkeleton({ rows = 3 }) {
    return (_jsx("div", { className: "space-y-3", "aria-busy": "true", "aria-label": "Lade Daten", children: Array.from({ length: rows }).map((_, i) => (_jsx(Card, { children: _jsx(CardContent, { className: "p-4", children: _jsxs("div", { className: "animate-pulse space-y-2", children: [_jsx("div", { className: "h-4 w-1/3 rounded bg-muted" }), _jsx("div", { className: "h-3 w-2/3 rounded bg-muted" })] }) }) }, i))) }));
}
